/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="file.model.ts" />
/// <reference path="file.service.ts" />
/// <reference path="../login/login.controller.ts" />
/// <reference path="../login/user.service.ts" />
/// <reference path="../../service/forge/forge.service.ts" />
/// <reference path="../building/building.service.ts" />
/// <reference path="../floorplan/floorplan.service.ts" />
/// <reference path="../map/map.service.ts" />

module Eseebase {
    export class FileController implements angular.IController {
        public files: FilePagedResult;
        public selectedFile: FileModel;
        public companies: OrganizationalUnitViewModel[];
        public extractOnlySelectedUnits: boolean;
        public extractOnlySimData: boolean;
        public selectedAssociation: OrganizationalUnitViewModel;
        public selectedDepartment: OrganizationalUnitViewModel;
        public errors: string[];
        public warnings: string[];
        public extra: string[];
        public filters: ModelFilterViewModel;
        public features: CompanyFeatureList;
        public filesToUpload: string[];
        $onInit = () => { };
        
        constructor(private $scope: any,
                    private organizationService: OrganizationService,
                    private $timeout: ng.ITimeoutService,
                    private $mdDialog: any,
                    private $mdToast: any,
                    private user: UserModel,
                    private buildingService: BuildingService,
                    private floorPlanService: FloorPlanService,
                    public fileService: FileService,
                    public mapService: MapService,
                    private $q: ng.IQService,
                    private textService: TextService,
                    private $window: ng.IWindowService,
                    private $rootScope: ng.IRootScopeService,
                    private forgeService: ForgeService,
                    private organizationSettingsService: OrganizationSettingsService,
                    private cookiesService: CookiesService,
                    private configuration: ConfigurationModel
        )
        {
            this.setupSignalR();
            this.extractOnlySelectedUnits = false;
            this.extractOnlySimData = false;
            this.filters = this.buildingService.getFilters();
            var vm = this;
            organizationSettingsService.getFeatures().then((features: CompanyFeatureList) => {
                vm.features = features;
                vm.filters.indoorBuildingPartType.groupBy = vm.features.includeIndoorData();
                vm.filters.category.groupBy = vm.features.includeOutdoorData();
                vm.filters.simFamilyTypeName.groupBy = vm.features.includeSimData();
            });
            
            this.loadOrganizations();
            $(window).on('resize', () => vm.openMenu(null, null));

            this.$scope.fileSelected = function (sender) {
                var data = new FormData();
                angular.forEach(sender.files, function (value) {
                    data.append("files[]", value);
                });
                var fileArray = [];
                for (var f of sender.files) {
                    fileArray.push(f.name);
                }
                jQuery('#fileReupload').val(null);
                vm.fileService.upload(vm.selectedFile.associationNumber, vm.selectedFile.departmentNumber, vm.selectedFile.extractOnlySelectedUnits, vm.selectedFile.extractOnlySimData, vm.selectedFile.id, fileArray.join(';'), data, (progress: number) => {
                    if (vm.files != null && vm.files.results) {
                        for (var f of vm.files.results) {
                            if (f.status == FileStatus[FileStatus.Uploading] && f.id == vm.selectedFile.id) {
                                f.progress = progress;
                            }
                        }
                    }
                })
                    .then((files) => { },
                    (error) => { });
                vm.selectedFile = null;
                vm.$rootScope.$broadcast('model-upload');
            }
            this.$rootScope.$on('filter-change', () => {
                vm.filters = vm.buildingService.getFilters();
                vm.files = new FilePagedResult();
                vm.loadFiles(1);
            });

            vm.files = new FilePagedResult();
            vm.loadFiles(1);

            $scope.tableScroll = function (sender: HTMLElement) {
                var bodyHeight = $(sender).height();
                var scrollTop = $(sender).scrollTop();
                var innerHeight = sender.scrollHeight;
                if (!vm.files.isLastPage() && scrollTop + bodyHeight > innerHeight - 280) {
                    vm.loadFiles(vm.files.pageNumber + 1);
                }
            }

            if (!this.files.results.some(f => f.progress < 25)) {
                window.onbeforeunload = null;
            }
            else {
                window.onbeforeunload = function () {
                    return true;
                };
            }
        }

        public onUploadError(error: any) {
            this.showAlert('Error', 'An error occured: ' + error);
        }

        public onUploadStart(eventArgs: UploadEventArgs) {
            this.$rootScope.$broadcast('model-upload');
            var vm = this;
            this.filesToUpload = eventArgs.fileNames;
            this.fileService.upload(eventArgs.associationNumber, eventArgs.departmentNumber, eventArgs.extractSelectedUnits, eventArgs.extractOnlySimData, eventArgs.fileId, eventArgs.fileNames.join(';'), eventArgs.formData, (progress: number) => {
                if (vm.files != null && vm.files.results) {
                    for (var f of vm.files.results) {
                        if (f.status == FileStatus[FileStatus.Uploading] && vm.filesToUpload.indexOf(f.fileName) > -1) {
                            f.progress = progress;
                        }
                    }
                }
            }).then(
                (files) => {
                    vm.filesToUpload = null;
                    if (files.data == '403') {
                        vm.onUploadError('You do not have permissions to upload to this organization');
                    }
                },
                (reason) => {
                    vm.filesToUpload = null;
                    vm.onUploadError(reason);
                });
        }

        public goToVerification(file: FileModel, $event) {
            if (file.status.toString() == FileStatus[FileStatus.Duplicate] || (file.status.toString() == FileStatus[FileStatus.Uploaded] && file.hasWarnings)) {
                this.selectedFile = file;
                var vm = this;
                var dialog = {
                    controller: FileController.WarningDialogController(vm),
                    controllerAs: 'vm',
                    templateUrl: '/app/dialog/warning-list.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    targetEvent: $event
                };
                this.$mdDialog.show(dialog)
                    .then(() => {
                        vm.fileService.getFileErrors(vm.selectedFile.id, 0).then((data: any) => {
                            vm.errors = data.errors;
                            vm.warnings = data.warnings;
                            vm.extra = data.extra;
                        });
                        if (file.status.toString() == FileStatus[FileStatus.Uploaded] && file.hasWarnings) {
                            vm.selectedFile.status = FileStatus[FileStatus.Verifying];
                        }
                        //else {
                        //    vm.selectedFile.status = FileStatus[FileStatus.Uploading];
                        //}
                        vm.selectedFile.progress = 0;
                        vm.fileService.submitFile(vm.selectedFile).then((data: any) => {
                            vm.fileFadeOut(data.duplicateIds);
                        });
                        vm.selectedFile = null;
                    }, () => { });
            }
            else if (file.status.toString() == FileStatus[FileStatus.Uploaded] && file.extractOnlySelectedUnits) {
                this.selectedFile = file;
                var vm = this;
                this.$mdDialog.show({
                    controller: function () { this.selectedFile = vm.selectedFile; this.$mdDialog = vm.$mdDialog; },
                    controllerAs: 'vm',
                    templateUrl: '/app/dialog/apartment-list.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    targetEvent: $event
                })
                    .then(function () {
                        if (vm.selectedFile.status == FileStatus[FileStatus.Uploaded]) {
                            vm.apartmentSelected();
                        }
                    }, () => { });
            }
        }

        public goToExtraction(file: FileModel, $event) {
            if (file.status != FileStatus[FileStatus.Error] && file.status != FileStatus[FileStatus.Verified]) {
                return;
            }
            this.selectedFile = file;
            
            var vm = this;
            var dialog = {
                controller: FileController.WarningDialogController(vm),
                controllerAs: 'vm',
                templateUrl: '/app/dialog/warning-list.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: $event
            };
            this.$mdDialog.show(dialog)
                .then(() => {
                    vm.fileService.getFileErrors(this.selectedFile.id, 0).then((data: any) => {
                        vm.errors = data.errors;
                        vm.warnings = data.warnings;
                        vm.extra = data.extra;
                    })
                    vm.selectedFile.status = FileStatus[FileStatus.Extracting];
                    vm.selectedFile.progress = 0;
                    vm.fileService.submitFile(vm.selectedFile);
                    vm.selectedFile = null;
                }, () => { });
        }

        public apartmentSelected() {
            var selectedApts = [];
            for (var aptIdx in this.selectedFile.selectedApartmentNumbers)
            {
                var apt = this.selectedFile.apartmentNumbers[aptIdx];
                if (apt != null && apt != '')
                {
                    selectedApts.push(apt);
                }
            }
            this.selectedFile.apartmentNumbers = selectedApts;
            this.fileService.submitFile(this.selectedFile);
            this.selectedFile.status = FileStatus[FileStatus.Verifying];
        }

        public fileDelete(file: FileModel, $event: any)
        {
            var confirm = this.$mdDialog.confirm()
                .title(this.textService.translate('ModelList_DeleteModel'))
                .textContent(this.textService.translate('ModelList_DeleteConfirmation').replace(/\{0\}/g, file.fileName))
                .ariaLabel(this.textService.translate('ModelList_DeleteModel'))
                .targetEvent($event)
                .ok(this.textService.translate('Button_OK'))
                .cancel(this.textService.translate('Button_Cancel'));

            var vm = this;
            return this.$mdDialog.show(confirm).then(() => {
                vm.showCompleteCorrectionDialog(file, $event).then(() => {
                    file.transparent = true;
                    vm.$timeout(() => {
                        vm.files.results = vm.files.results.filter(f => f.id != file.id);
                    }, 600);
                    vm.fileService.deleteFile(file.id).then(() => {
                    }, () => {
                        vm.showAlert('Error', 'Could not delete file ' + file.fileName);
                        vm.$timeout(() => {
                            vm.files.results.push(file);
                        }, 600);
                    });
                });
            }, () => { });
        }

        private showAlert(title: string, message: string) {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(title)
                    .textContent(message)
                    .ok('OK')
            );
        }

        public reUpload(file: FileModel, $event)
        {
            this.selectedFile = file;
            jQuery('#fileReupload').trigger('click');
        }

        public reRun(file: FileModel, $event) {
            var vm = this;
            file.status = FileStatus[FileStatus.Uploading];
            file.progress = 0;
            file.isRerunScheduled = false;
            vm.$rootScope.$broadcast('rerun-model', { fileId: file.id });
            vm.fileService.rerunFile(file.id);
        }

        public create(file: FileModel, $event) {
            var vm = this;
            var dialog = {
                locals: { file: file },
                controller: 'ModelCreatorController',
                controllerAs: 'mcvm',
                templateUrl: '/app/dialog/model-creator-file-select.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                targetEvent: $event,
                //escapeToClose: false,
                multiple: true
            };
            this.$mdDialog.show(dialog);

            //file.status = FileStatus[FileStatus.Creating];
        }

        public toggleInCanea(file: FileModel) {
            var vm = this;
            if (file.showInCanea) {
                vm.fileService.disableInCanea(file.id).then(() => {
                    file.showInCanea = !file.showInCanea;
                }, () => {
                });
            }
            else {
                vm.fileService.enableInCanea(file.id).then(() => {
                    file.showInCanea = !file.showInCanea;
                }, () => {
                });
            }
        }

        public openMenu(file: FileModel, $event: any) {
            if (file != null) {
                window.event.stopPropagation();
                this.$rootScope.$broadcast('menu-open', { file: file, $event: $event });
            }
        }

        public filterChanged() {
            this.files = new FilePagedResult();
            this.loadFiles(1);
        }

        public getCreateMode(file: FileModel) {
            if (file.status == FileStatus[FileStatus.Creating]) {
                return StatusMode[StatusMode.Progress];
            }
            // else if (file.status == FileStatus[FileStatus.Duplicate] || (file.status == FileStatus[FileStatus.Uploaded] && (file.extractOnlySelectedUnits || file.hasWarnings))) {
            //     return StatusMode[StatusMode.Warning];
            // }
            else if (file.status == FileStatus[FileStatus.Created] ||
                file.status == FileStatus[FileStatus.Uploading] ||
                file.status == FileStatus[FileStatus.Uploaded] ||
                file.status == FileStatus[FileStatus.Verifying] ||
                file.status == FileStatus[FileStatus.Verified] ||
                file.status == FileStatus[FileStatus.Extracting] ||
                file.status == FileStatus[FileStatus.Extracted] ||
                file.status == FileStatus[FileStatus.Error] ||
                file.status == FileStatus[FileStatus.Duplicate]) {
                return StatusMode[StatusMode.Completed];
            }
        }

        public getUploadMode(file: FileModel) {
            if (file.status == FileStatus[FileStatus.Uploading]) {
                return StatusMode[StatusMode.Progress];
            }
            else if (file.status == FileStatus[FileStatus.Duplicate] || (file.status == FileStatus[FileStatus.Uploaded] && (file.extractOnlySelectedUnits || file.hasWarnings))) {
                return StatusMode[StatusMode.Warning];
            }
            else if (file.status == FileStatus[FileStatus.Uploaded] ||
                file.status == FileStatus[FileStatus.Verifying] ||
                file.status == FileStatus[FileStatus.Verified] ||
                file.status == FileStatus[FileStatus.Extracting] ||
                file.status == FileStatus[FileStatus.Extracted] ||
                file.status == FileStatus[FileStatus.Error]) {
                return StatusMode[StatusMode.Completed];
            }
        }

        public getVerifyMode(file: FileModel) {
            if (file.status == FileStatus[FileStatus.Verifying]) {
                return StatusMode[StatusMode.Progress];
            }
            if (file.status == FileStatus[FileStatus.Verified] || file.status == FileStatus[FileStatus.Error]) {
                return StatusMode[StatusMode.Warning];
            }
            if (file.status == FileStatus[FileStatus.Extracting] ||
                file.status == FileStatus[FileStatus.Extracted]) {
                return StatusMode[StatusMode.Completed];
            }
        }

        public getExtractMode(file: FileModel) {
            if (file.status == FileStatus[FileStatus.Extracting]) {
                return StatusMode[StatusMode.Progress];
            }
            if (file.status == FileStatus[FileStatus.Extracted]) {
                return StatusMode[StatusMode.Completed];
            }
        }

        public expandDetails(fileId: string, $event) {
            if ($event != null && $event.target != null) {

                if (angular.element($event.target).hasClass('active')) {
                    angular.element($event.target).removeClass('active');
                }
                else {
                    angular.element($event.target).addClass('active');
                }
                this.$rootScope.$broadcast('model-expand-collapse', { fileId: fileId });
            }
        }

        public onForgeJobSchedule = (file: FileModel) => {
            var vm = this;
            this.forgeService.uploadModel(file.associationNumber, file.departmentNumber, file.fileName, file.id)
                .then(() => vm.showAlert('eseebase', 'A translation task has been scheduled'),
                (rejection) => vm.showAlert('error', 'An error has occured: ' + rejection.status + ': ' + rejection.statusText));
        }

        public canUpload() {
            return this.user.roles.indexOf('Upload Model') > -1;
        }

        private fileFadeOut(fileIds: string[]) {
            if (fileIds == null || fileIds.length == 0) {
                return;
            }
            for (var i = this.files.results.length - 1; i >= 0; i--) {
                if (fileIds.indexOf(this.files.results[i].id) > -1) {
                    this.files.results[i].transparent = true;
                }
            }
            var vm = this;
            this.$timeout(() => {
                vm.files.results = vm.files.results.filter(f => fileIds.indexOf(f.id) == -1);
            }, 600);
        }

        private loadOrganizations() {
            var vm = this;
            vm.organizationService.list().then((response: OrganizationalUnitViewModel[]) => {
                vm.companies = response;
            });
        }

        private loadFiles(pageNumber: number) {
            if (this.files.isLastPage() || this.files.pageNumber == pageNumber) {
                return;
            }
            var oldPageNumber = this.files.pageNumber;
            this.files.pageNumber = pageNumber;
            this.files.totalNumberOfPages = -1;
            var vm = this;
            this.fileService.getFilesPaged(this.filters, pageNumber).then((data: FilePagedResult) => {
                vm.files.totalNumberOfPages = data.totalNumberOfPages;
                vm.files.totalNumberOfRecords = data.totalNumberOfRecords;
                vm.files.results = vm.files.results.concat(data.results);
            }, () => {
                vm.files.pageNumber = oldPageNumber;
            });
            vm.selectedFile = null;
        }

        private setupSignalR()
        {
            var vm = this;
            $.connection.communicationHub.client.broadcastMessage = function (message: string) {
                var file = <FileModel>JSON.parse(message);
                if (file != null && vm.files != null) {
                    if (vm.user.roles.indexOf('Angel') == -1 && vm.user.organizationalUnitIds.indexOf(file.organizationalUnitId) == -1) {
                        return;
                    }
                    vm.$timeout(() => {
                        var companyNumber = vm.cookiesService.readCookie('company');
                        var idx = (<any>vm.files.results).findIndex(f => f.id == file.id);
                        if (idx > -1) {

                            vm.files.results[idx].apartmentNumbers = file.apartmentNumbers;
                            vm.files.results[idx].extractOnlySelectedUnits = file.extractOnlySelectedUnits;
                            vm.files.results[idx].extractOnlySimData = file.extractOnlySimData;
                            vm.files.results[idx].fileName = file.fileName;
                            vm.files.results[idx].status = file.status;
                            vm.files.results[idx].progress = file.progress;
                            vm.files.results[idx].associationNumber = file.associationNumber;
                            vm.files.results[idx].departmentNumber = file.departmentNumber;
                            vm.files.results[idx].projectAddress = file.projectAddress;
                            vm.files.results[idx].projectGeoLocation = file.projectGeoLocation;
                            vm.files.results[idx].fileUrl = file.fileUrl;
                            vm.files.results[idx].revitVersion = file.revitVersion;
                            vm.files.results[idx].localizer = file.localizer;
                            vm.files.results[idx].ifcUrl = file.ifcUrl;
                            vm.files.results[idx].hasOutdoorGeometry = file.hasOutdoorGeometry;
                            vm.files.results[idx].hasApartmentsGeometry = file.hasApartmentsGeometry;
                            vm.files.results[idx].hasRoomGeometry = file.hasRoomGeometry;
                            if (file.status == FileStatus[FileStatus.Extracted])
                            {
                                vm.$mdToast.show(
                                    vm.$mdToast.simple()
                                        .textContent(vm.textService.translate('ModelList_ModelIsExtracted').replace(/\{0\}/g, file.fileName))
                                        .parent(document.querySelectorAll('#toaster'))
                                        .position('bottom center')
                                        .hideDelay(5000)
                                );
                            }
                        }
                        else if (file.id != null && file.id != '' && file.customerNumber == companyNumber) {
                            var newFile = new FileModel();
                            newFile.id = file.id;
                            newFile.extractOnlySelectedUnits = file.extractOnlySelectedUnits;
                            newFile.extractOnlySimData = file.extractOnlySimData;
                            newFile.fileName = file.fileName;
                            newFile.status = file.status;
                            newFile.progress = file.progress;
                            newFile.associationNumber = file.associationNumber;
                            newFile.departmentNumber = file.departmentNumber;
                            newFile.fileUrl = file.fileUrl;
                            newFile.revitVersion = file.revitVersion;
                            newFile.ifcUrl = file.ifcUrl;
                            newFile.hasOutdoorGeometry = file.hasOutdoorGeometry;
                            newFile.hasApartmentsGeometry = file.hasApartmentsGeometry;
                            newFile.hasRoomGeometry = file.hasRoomGeometry;
                            vm.files.results.unshift(newFile);
                            vm.files.totalNumberOfRecords++;
                            window.onbeforeunload = function () {
                                return true;
                            };
                        }
                        if (!vm.files.results.some(f => f.progress <= 0)) {
                            window.onbeforeunload = null;
                        }
                    });
                    
                }
            };
            $.connection.hub.start();

            $.connection.hub.disconnected(function () {
                setTimeout(function () {
                    $.connection.hub.start();
                }, 5000); // Restart connection after 5 seconds.
            });
        }

        public showCompleteCorrectionDialog(file: FileModel, $event) {
            var def = this.$q.defer();
            this.fileService.hasCorrections(file.id).then((result) => {
                if (result) {
                    var confirm = this.$mdDialog.confirm()
                        .title(this.textService.translate('ModelList_CompleteCorrectionTitle'))
                        .textContent(this.textService.translate('ModelList_CompleteCorrectionConfirmation').replace(/\{0\}/g, file.fileName))
                        .ariaLabel(this.textService.translate('ModelList_CompleteCorrectionTitle'))
                        .targetEvent($event)
                        .ok(this.textService.translate('Button_OK'))
                        .cancel(this.textService.translate('Button_Cancel'));

                    this.$mdDialog.show(confirm).then(() => {
                        def.resolve();
                    }, () => {
                        def.reject();
                    });
                }
                else {
                    def.resolve();
                }
            }, () => def.reject());
            

            return def.promise;
        }

        public static WarningDialogController = (vm: any) => {
            return function() {
                this.selectedFile = vm.selectedFile;
                this.fileService = vm.fileService;
                this.projectAddress = this.selectedFile.projectAddress;
                this.associationNumber = this.selectedFile.associationNumber;
                this.departmentNumber = this.selectedFile.departmentNumber;
                this.$mdDialog = vm.$mdDialog;
                this.overwriteConflict = false;
                this.addressNotFound = false;
                this.canUpload = vm.canUpload();
                this.errors = null;
                this.pageNumber = 0;
                this.loading = false;
                this.isLastPage = false;
                var self = this;
                this.fileService.getFileErrors(this.selectedFile.id, this.pageNumber).then((data: UploadingErrorPagedResult) => {
                    self.errors = data;
                    self.isLastPage = data == null || data.results == null || data.results.length < 10;
                })
                this.closeAndProceed = function () {
                    this.selectedFile.associationNumber = this.associationNumber;
                    this.selectedFile.departmentNumber = this.departmentNumber;
                    this.selectedFile.projectAddress = this.projectAddress;
                    vm.fileService.canOverwrite(vm.selectedFile.associationNumber, vm.selectedFile.departmentNumber, vm.selectedFile.localizer).then((response: boolean) => {
                        if (!response) {
                            self.overwriteConflict = true;
                        }
                        else {
                            if (vm.selectedFile.projectGeoLocation == null && vm.selectedFile.projectAddress != null) {
                                vm.mapService.lookupAddress(vm.selectedFile.projectAddress).then((response) => {
                                    vm.selectedFile.projectGeoLocation = response ? <Coordinates>response.data : null;
                                    if (response == null) {
                                        vm.selectedFile.projectAddress = '';
                                        self.addressNotFound = false;
                                    }
                                    else {
                                        vm.$mdDialog.hide();
                                    }
                                }, () => {
                                    vm.selectedFile.projectAddress = '';
                                    self.addressNotFound = true;
                                });
                            }
                            else {
                                vm.$mdDialog.hide();
                            }
                        }
                    });
                };
                this.getDialogHeader = function () {
                    if (self.errors != null && self.errors.results != null && self.errors.results.length > 0) {
                        return self.errors.totalNumberOfRecords + ' ' + vm.textService.translate('WarningList_ErrorsAndWarnings');
                    }
                }
                this.hasErrors = function () {
                    if (self.errors != null && self.errors.results != null && self.errors.results.length > 0) {
                        return self.errors.results.some(e => e.stopProcessing);
                    }
                    return false;
                }
                this.onListScroll = function (sender) {
                    if (!self.loading && !self.isLastPage && $(sender).scrollTop() + $(sender)[0].clientHeight > $(sender).filter('.error-list').height() - 80) {
                        self.loading = true;
                        self.pageNumber++;
                        self.fileService.getFileErrors(self.selectedFile.id, self.pageNumber).then((data: UploadingErrorPagedResult) => {
                            if (self.errors != null && self.errors.results != null && data.results.length > 0) {
                                self.errors.results = self.errors.results.concat(data.results);
                            }
                            self.isLastPage = data == null || data.results == null || data.results.length < 10;
                            self.loading = false;
                        }, () => {
                            self.loading = false;
                        });
                    }
                }
            }
        }
    }

    FileController.$inject = ['$scope', 'OrganizationService', '$timeout', '$mdDialog', '$mdToast', 'user', 'BuildingService', 'FloorPlanService', 'FileService', 'MapService', '$q', 'TextService', '$window', '$rootScope', 'ForgeService', 'OrganizationSettingsService', 'CookiesService', 'configuration'];

    angular
        .module('eseebase')
        .controller('FileController', FileController);
}
